export const TranslationsKM = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "បញ្ជាទិញតាមអ៊ីនធើណិត",
        cart: "កន្ត្រក",
        open_24: "២៤ ម៉ោង",
        closed: "បិទ",
        free: "ឥតគិតថ្លៃ",
        something_went_wrong: "មានអ្វីមួយមិនប្រក្រតី",
        try_again: "សាកល្បងម្ដងទៀត",
    },
    constants: {
        calendar: {
            days: {
                monday: "ថ្ងៃច័ន្ទ",
                tuesday: "ថ្ងៃអង្គារ",
                wednesday: "ថ្ងៃពុធ",
                thursday: "ថ្ងៃព្រហស្បតិ៍",
                friday: "ថ្ងៃសុក្រ",
                saturday: "ថ្ងៃសៅរ៌",
                sunday: "ថ្ងៃអាទិត្យ",
            },
        },
        services: {
            pickup: "មកយក",
            delivery: "ដឹកជញ្ជូន",
            dine_in: "ទទួលទានអាហារក្នុងហាង",
            table_booking: "ការកក់តុ",
        },
        payment: {
            method: {
                cash: "សាច់ប្រាក់",
                card: "កាត",
                stripe: "កាតឥណទាន",
                paypal: "បង់ប្រាក់តាមរយះPayPal",
                cardconnect: "កាតឥណទាន",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "បង់តាម Bambora APAC",
                pesapal: "Pesapal",
                custom: "ធ្វើតាមការកម្ម៉ង",
            },
            backend_method: {
                cash: "សាច់ប្រាក់",
                card: "កាត",
                stripe: "ឆ្នូត",
                paypal: "បង់ប្រាក់",
                cardconnect: "ភ្ជាប់កាត",
                paygate_payweb: "បង់តាម PayGate Payweb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "បង់តាម Bambora APAC",
                pesapal: "Pesapal",
                custom: "ធ្វើតាមការកម្ម៉ង",
            },
            status: {
                success: "ជោគជ័យ",
                pending: "កំពង់រងចាំ",
                error: "គាំង",
                refunded: "បានសងប្រាក់វិញ",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "យកចេញ",
                drop_here: "ទម្លាក់ឯកសាររបស់អ្នកនៅទីនេះឬក៏ចុចដើម្បីជ្រើសរើសមួយ",
                accepts: "ទទួលយ {{fileTypes}} កឯកសារ",
                errors: {
                    max_files: "ទទួលយ {{number}} កអតិបរមា",
                    max_size: "ទទួលយកឯកសារទំហំ {{kilobytes}} គីកាបាយ",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "ហាងបានបិទហើយលោកអ្នកមិនអាចកំម៉្មងការពិសារអាហារក្នុង",
            },
            buttons: {
                order: {
                    book_order: "កក់តុ / បញ្ជាទិញតាមអ៊ីនធើណេត",
                    order_online: "កក់តាមអ៊ីនធើណិត",
                    book_table: "កក់តុ",
                    order: "កម្មង់",
                    book: "កក់",
                    cart: "កន្ត្រក",
                    restart: "ចាប់ផ្តើមឡើងវិញ",
                    closed: "ហាងបានបិទ",
                    not_accepting: "មិនទទួលយកការកម្មង់",
                },
            },
        },
        modals: {
            auth: {
                login: "ចូល",
                register: "ចុះឈ្មោះ",
                register_commence: "បន្ត",
                register_complete: "បង្កើតគណនី",
                register_confirmation_sent: "លេខកូដបញ្ជាក់ត្រូវបានផ្ញើរទៅកាន់អ៊ីមែលរបស់អ្នក.សូមបញ្ចូល",
                register_confirmation_resent: "លេខកូដបញ្ជាក់បានផ្ញើរទៅអ្នកម្តងទៀតហើយ សូមចូលត្រួតពិនិត្យមើលនៅក្នុងស្ពេម រឺអាចចាប់ផ្តើមដំណើរការរបស់វាម្តងទៀត",
                register_restart: "ចាប់ផ្ដើមឡើងវិញ",
                register_resend_code: "ផ្ញើរកូដសារជាថ្មី",
                login_placeholder: "អ៊ីមែល",
                password_placeholder: "លេខកូតសម្ងាត់",
                confirm_password_placeholder: "បញ្ជាក់ពាក្យសម្ងាត់",
                confirmation_code_placeholder: "លេខកូដបញ្ជាក់អ៊ីមែល",
                accept_terms: "ទទួលយកលក័្ខខណ្ឌ",
                accept_terms_view: "មើល",
                login_facebook: "ភ្ជាប់ជាមួយ Facebook",
                login_google: "ភ្ជាប់ជាមួយ Google",
                benefits: "ចូលឬបង្កើតគណនីដើម្បីរក្សារទុកការបញ្ជាទិញរបស់អ្នក",
                logged_in: "ចូលដោយជោគជ័យ",
                logged_out: "ចាកចេញ",
                password_reset: {
                    init_button: "ផ្ញើរអ៊ីមែលកំណត់ពាក្យសម្ងាត់ឡើងវិញ",
                    init_success: "តំណកំណត់ពាក្យសម្ងាត់ត្រូវបានផ្ញើរទៅអ៊ីមែលរបស់អ្នក",
                    complete_button: "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
                    complete_success: "ពាក្យសម្ងាត់កំណត់ឡើងវិញដោយជោគជ័យចូលជាមួយពាក្យ",
                    forgot_password_text: "សម្ងាត់ថ្មីរបស់អ្នក? ",
                    forgot_password_link: "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
                    remember_password_text: "ចងចាំពាក្យសម្ងាត់របស់អ្នក? ",
                    remember_password_link: "ត្រឡប់ក្រោយ",
                    invalid_title: "ពាក្យសម្ងាត់់ដែលដាក់ឡើងវិញមិនត្រឹមត្រូវ",
                    invalid_description: "តំណកំណត់លេខសម្ងាត់មិនត្រឹមត្រូវសូមស្នើសុំសារជាថ្មី",
                    invalid_link: "ចូលទៅភ្ជាប់",
                    title: "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
                    description: "បញ្ចូលពាក្យសម្ងាត់ថ្មីសម្រាប់គណនីរបស់អ្នក",
                },
                error_generic: "មានអ្វីមួយមិនប្រក្រតីសូមព្យាយាមម្ដងទៀតឬទាក់ទងមកយើងខ្ញុំ",
                error_accept_terms: "សូមទទួលយកលក័្ខខណ្ឌ",
                error_password_length: "អប្បបរមា ៦ តួអក្សរសម្រាប់លេខសម្ងាត់",
                error_social: "មានអ្វីមួយមិនប្រក្រតីសូមព្យាយាមម្ដងទៀតឬទាក់ទងមកយើងខ្ញុំ",
                error_confirmation_code: "កូដបញ្ជាក់មិនត្រឹមត្រូវ",
                error_invalid_code: "កូដបញ្ជាក់មិនត្រឹមត្រូវ",
                error_exists: "អ្នកប្រើមានរួចហើយ",
                error_invalid_email_pass: "អាស័យដ្ឋានអ៊ីមែលឬលេខសម្ងាត់មិនត្រឹមត្រូវ",
                error_password_no_match: "លេខកូតសម្ងាត់មិនត្រឹមត្រូវគ្នាទេ",
                error_user_not_found: "មិនមានអ្នកប្រើប្រាស់ដែលមានអាស័យដ្ឋានអ៊ីមែលដូចនេះទេ",
                error_invalid_email: "អាស័យដ្ឋានអ៊ីមែលឬលេខសម្ងាត់មិនត្រឹមត្រូវ",
                error_invalid_reset_token: "តំណកំណត់ឡើងវិញមិនត្រឹមត្រូវស្នើសុំមួយផ្សេងទៀត",
            },
            booking: {
                form: {
                    name: "ឈ្មោះពេញ",
                    email: "អាស័យដ្ឋានអ៊ីមែល",
                    phone: "លេខទូរស័ព្ទ",
                    number_of_people: "ចំនួនមនុស្ស",
                    number_of_people_max: "ចំនួនមនុស្ស ({{max_people}} អតិបរមា)",
                    number_of_people_min: "ចំនួនមនុស្ស ({{min_people}} អប្បបរមា)",
                    number_of_people_max_min: "ចំនួនមនុស្ស (រវាង {{min_people}} ទៅ {{max_people}})",
                    notes: "កំណត់ចំណាំ/សំណូមពរពិសេស",
                    submit: "បញ្ជូនសំណើរកក់",
                    email_optional: "(ស្រេចចិត្ត)",
                    date: "កាលបរិច្ឆេទ",
                    duration: "រយៈពេល",
                    seating: "ម៉ោងទំនេរ",
                    number_of_guests: "ចំនួនភ្ញៀវ",
                    notes_placeholder: "អាឡែស៊ី ឱកាស ការពេញចិត្តកន្លែងអង្គុយ",
                    reserving: "កំពុងកក់...",
                    reserve_table: "កក់តុ",
                    please_choose_a_date_and_time: "សូមជ្រើសរើសកាលបរិច្ឆេទ និងម៉ោង។",
                    invalid_people: "ចំនួនមនុស្សត្រូវនៅចន្លោះ {{min}} និង {{max}}។",
                    party_size_max_fallback: "ចំនួនអតិបរមាដែលអនុញ្ញាត",
                    loading_available_times: "កំពុងផ្ទុកម៉ោងទំនេរ…",
                    select_a_date_to_see_available_times: "ជ្រើសរើសកាលបរិច្ឆេទដើម្បីមើលម៉ោងទំនេរ។",
                    no_times_available_for_this_date: "គ្មានម៉ោងទំនេរសម្រាប់កាលបរិច្ឆេទនេះទេ។ សូមជ្រើសរើសថ្ងៃផ្សេង។",
                    shift: "វេន",
                    service_times: "ម៉ោងបម្រើ",
                    new_shift: "វេនថ្មី",
                    time: "ម៉ោង",
                    times: "ម៉ោង",
                    unavailable: "មិនទំនេរ",
                    available: "ទំនេរ",
                    required_name: "សូមបញ្ចូលឈ្មោះរបស់អ្នក។",
                    required_phone: "សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក។",
                    required_email: "សូមបញ្ចូលអ៊ីមែលរបស់អ្នក។",
                    invalid_email: "សូមបញ្ចូលអ៊ីមែលត្រឹមត្រូវ។",
                    required_terms: "សូមយល់ព្រមលក្ខខណ្ឌមុនពេលកក់។",
                    missing_custom_fields: "សូមឆ្លើយសំណួរចាំបាច់ទាំងអស់។",
                    reservation_is_unavailable: "ការកក់មិនអាចប្រើបានទេ។",
                    please_contact_the_restaurant_directly: "សូមទាក់ទងភោជនីយដ្ឋានដោយផ្ទាល់។",
                    almost_done: "ជិតរួចរាល់",
                    your_details: "ព័ត៌មានរបស់អ្នក",
                    tell_us_who_s_coming: "ប្រាប់យើងថានរណាមក ដើម្បីឱ្យយើងបញ្ជាក់ការកក់របស់អ្នក។",
                    book_your_table: "កក់តុរបស់អ្នក",
                    choose_a_time_that_works_for_you: "ជ្រើសរើសម៉ោងដែលសមស្របសម្រាប់អ្នក។",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "ផ្ញើសំណើកក់របស់អ្នក ហើយភោជនីយដ្ឋាននឹងរៀបចំនៅសល់។",
                    select_date: "ជ្រើសរើសកាលបរិច្ឆេទ",
                    standard: "ស្តង់ដារ",
                    minutes: "នាទី",
                    next: "បន្ទាប់ →",
                    back: "← ថយក្រោយ",
                    accept_terms: "ខ្ញុំយល់ព្រមលក្ខខណ្ឌ។",
                    info_1: "អ្នកនឹងទទួលបានដំណឹងតាមរយះអ៊ីមែលនៅពេលដែលការកក់របស់អ្នកត្រូវបានទទួលឬបដិសេធ",
                },
                errors: {
                    not_found: "មិនមានការកក់នេះទេ។ការកក់នេះអាចត្រូវបានលុបចោល",
                    generic: "មានអ្វីមួយមិនប្រក្រតី សូមមេត្តាចុចលើគេហរទំព័រឡើងវិញម្តងទៀតឬទំនាក់ទំនងមកយើងខ្ញុំ។",
                    something_went_wrong: "មានអ្វីមួយមិនប្រក្រតី",
                    accept_terms: "សូមទទួលយកលក័្ខខណ្ឌ",
                    required_phone: "សូមបំពេញលេខទូរស័ព្ទរបស់អ្នក",
                    required_email: "សូមបំពេញអ៊ីមែលរបស់អ្នក",
                    required_name: "សូមបំពេញឈ្មោះរបស់អ្នក",
                    invalid_email: "សូមបញ្ចូលអាស័យដ្ឋានអ៊ីមែលដែលត្រឹមត្រូវ",
                    invalid_phone: "សូមបញ្ចូលលេខទូរស័ព្ទដែលត្រឹមត្រូវ",
                    invalid_people: "ចំនួនមនុស្សមិនត្រឹមត្រូវ",
                    booking_capacity_threshold: "ម៉ោងនេះពេញហើយ។ សូមសាកល្បងម៉ោងផ្សេង។",
                    slot_unavailable: "ចំនួនមនុស្សនេះពេញហើយ។ សូមសាកល្បងម៉ោងផ្សេង។",
                    booking_date_paused: "ការកក់សម្រាប់កាលបរិច្ឆេទនេះត្រូវបានផ្អាក។ សូមជ្រើសរើសថ្ងៃផ្សេង។",
                    invalid_table_assignment: "តុទាំងនោះមិនអាចផ្ទុកក្រុមរបស់អ្នកបានទេ។ សូមជ្រើសរើសម៉ោងផ្សេង។",
                    exceeded_order_limit: "សំណើកក់ច្រើនពេក។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។",
                    validation_failed_recaptcha_v3: "បានរកឃើញចរាចរណ៍ខុសធម្មតា។ តើអ្នកកំពុងប្រើ VPN ទេ? សូមបញ្ចប់ការផ្ទៀងផ្ទាត់ខាងលើ ហើយព្យាយាមម្តងទៀត។",
                    validation_failed_recaptcha_v2: "មិនអាចចាប់ផ្តើមការកក់បានទេ។ សូមព្យាយាមម្តងទៀត ឬប្រើវិធីផ្សេង។ បើអ្នកប្រើ VPN សូមបិទវាជាមុនសិន។",
                    booking_already_exists: "ការកក់នេះត្រូវបានផ្ញើរួចហើយ។ ពិនិត្យអ៊ីមែលរបស់អ្នក ឬបើកតំណការកក់។",
                    invalid_party_size: "សូមជ្រើសរើសចំនួនមនុស្សដែលត្រឹមត្រូវ។",
                    invalid_request: "សំណើមិនត្រឹមត្រូវ។ សូមផ្ទុកទំព័រឡើងវិញ ហើយព្យាយាមម្តងទៀត។",
                    table_booking_unavailable: "ការកក់តុមិនអាចប្រើបានទេ។",
                },
            },
            cart: {
                title: "កន្ត្រក",
                proceed_to_checkout: "បន្តទៅមុខដើម្បី ចាកចេញ",
                edit_dish: "កែប្រែ",
                remove_dish: "ដកចេញ",
                no_items_1: "មិនមានការកំម្ម៉ងនៅក្នុងកន្ត្រកទេ",
                no_items_2: "សូមបន្ថែមមុនសិនដើម្បីបន្ត",
                free_delivery_notice: "ការដឹកជញ្ជូនដោយឥតគិតថ្លៃសម្រាប់ការបញ្ជាទិញលើសពី {{value, currency}}",
                errors: {
                    min_order_promo: "ការបញ្ជាទិញមានតម្លៃអប្បរមាស្មើរនិង {{value, currency}} ដើម្បីធ្វើការដឹកជញ្ជូន",
                    min_order_delivery: "ការបញ្ជាទិញមានតម្លៃអប្បរមាស្មើរនិង {{value, currency}} ដើម្បីធ្វើការដឹកជញ្ជូន",
                },
                promo: {
                    heading: "កូដបញ្ចុះតម្លៃ",
                    placeholder: "បញ្ចូលកូដបញ្ចុះតម្លៃ",
                    add: "ថែមកូដ",
                    title: "ការផ្សព្វផ្សាយ {{name}} ត្រូវបានបន្ថែមនៅក្នុងកន្ត្រក",
                    fixed_discount: "{{value, currency}} បញ្ចុះថ្លៃ",
                    percent_discount: "{{value}}% បញ្ចុះថ្លៃ",
                    added_to_cart: "ប្រម៉ូសិនបានដាក់នៅក្នុងកន្ត្រក",
                    errors: {
                        not_found: "មិនមានប្រម៉ូសិនទេ",
                        disabled: "ប្រូម៉ូសិនត្រូវបានបញ្ចប់",
                        not_available: "មិនមានប្រម៉ូសិនទេ",
                        logged_in_only: "សូមចូលភ្ជាប់ជាមុនសិនដើម្បីអាចប្រើប្រូម៉ូសិននេះបាន",
                        already_used: "អ្នកបានប្រើប្រូម៉ូសិននេះរួចហើយ",
                        invalid: "ប្រូម៉ូសិននេះលែងមានសុពលភាពទៀតហើយ",
                        invalid_service: "ប្រូម៉ូសិននេះមិនមានសុពលភាពសម្រាប់សេវាកម្មដែលអ្នកជ្រើសរើសទេ",
                        later_only: "មានសុពលភាពសម្រាប់តែការបញ្ជាទិញជាមុនបុណ្ណោះ",
                        now_only: "មានសុពលភាពសម្រាប់តែការបញ្ជាទិញនាពេលនេះ",
                        generic: "អូ...អាចមានបញ្ហាហើយ",
                        dishes_required_multi: "ប្រូម៉ូសិននេះនឹងត្រូវបានអនុវត្តនៅពេលដែលចំនួនកំម៉្មងកំណត់ណាមួយត្រូវបានបញ្ចូលទៅក្នុងកន្ត្រករបស់អ្នក",
                        dishes_required_single: " ការផ្ដល់ជូនពិសេសនេះនិងត្រូវបានអនុវត្តចំពោះ '{{dish}}'",
                    },
                },
                tip: {
                    title: "លុយធីប",
                    placeholder: "អោយលុយធីបបន្ថែម",
                },
            },
            checkout: {
                title: "ពិនិត្យមុនពេលចេញ",
                subtitle: "បញ្ជាក់លំអិតការបញ្ជាទិញរបស់អ្នក",
                details: {
                    service: "សេវាកម្ម",
                    due: "ដោយសារ",
                    due_now_asap: "ឥឡូវ/ កាន់តែឆាប់កាន់តែល្អ",
                    address: "អាស័យដ្ឋានសម្រាប់ការដឹកជញ្ជូន",
                    total: "សរុប",
                    table: "តុ",
                    store_location: "អាស័យដ្ឋានហាង",
                },
                customer: {
                    title: "ភ្ញៀវ",
                    subtitle: "ចូលភ្ជាប់ដើម្បីរក្សាទុកការបញ្ជាទិញនិងព័ឥមានផ្សេងៗរបស់អ្នក",
                    button: "ភ្ជាប់ចូល",
                    name: "ឈ្មោះពេញ",
                    email: "អាស័យដ្ឋានអ៊ីមែល",
                    phone: "លេខទូរស័ព្ទ",
                    phone_important: "លេខទូរស័ព្ទ(សំខាន់)",
                    notes: "កំណត់ត្រាបញ្ជាទិញ",
                    delivery_notes: "សេចក្ដីណែនាំស្ដីពីការដឹកជញ្ជូន/កំណត់ត្រាបញ្ជាទិញ",
                    optional: "អាចរើសបាន"
                },
                payment: {
                    title: "វិជីសាស្រ្ដទូទាត់",
                },
                accept_terms: "ទទួលយកលក័្ខខណ្ឌ",
                accept_terms_view: "ផ្ទៀងផ្ទាត់មើល",
                processing_order: "ដំណើរការបញ្ជាទិញ",
                warning: {
                    different_payment_currency: "តម្លៃហាងគឺគិតជារូបិយប័ណ្ណ {{store_currency}} ប៉ុន្តែវិធីសាស្រ្តទូទាត់ជារូបិយប័ណ្ណ {{payment_currency}}",
                    closing_soon: "ហាងនឹងបិទនាពេលបន្តិចទៀតនេះ។ សូមមេត្តាធ្វើការកំម្ម៉ងក្នុងរយះពេល {{value}} នាទី",
                    closed: "សូមអភ័យទោសសេវាកម្មនេះត្រូវាបានបិទហើយការបញ្ជាទិញមិនត្រូវបានទទួលយកទេ",
                    expired: "យើងមិនអាចទទួលយកការកំម្ម៉ងរបស់អ្នកបានទេនាពេលនេះ។សូមធ្វើការកំម្ម៉ងនាពេលក្រោយ។",
                },
                errors: {
                    stripe_generic: "កាតឥណទានរបស់អ្នកមិនអាចធ្វើការទូទាត់បាន។សូមព្យាយាមម្ដងទៀតឬតាមវិធីសាស្ត្រផ្សេងៗ",
                    stripe_loading_fail: "មានបញ្ហារអាក់រអួលពេលបង់ប្រាក់។សូមមេត្តាព្យយាមម្តងទៀត",
                    something_went_wrong: "មានបញ្ហារអាក់រអួល",
                    paypal_generic: "មានបញ្ហារអាក់រអួលជាមួយការបង់ប្រាក់តាមPayPal។ សូមមេត្តាព្យាយាមម្តងទៀត ឫក៏សាកល្បងជាមួយការបង់ប្រាកផ្សេងទៀតដែលមាន។ ",
                    payment_fail: "មានបញ្ហារអាក់រអួលជាមួយការបង់ប្រាក់។ សូមមេត្តាព្យាយាមម្តងទៀត ឫក៏សាកល្បងជាមួយការបង់ប្រាកផ្សេងទៀតដែលមាន។ ",
                    payment_cancelled: "ការបង់ប្រាក់របស់អ្នកត្រូវបានលប់ចោល។សូមព្យាយាមម្ដងទៀតឬជ្រើសរើសវិធីសាស្រ្តទូទាត់ផ្សេងទៀតដែលមាន។",
                    payment_error: "ដំណើរការការទូទាត់តាមអ៊ីធឺណិតមានការរអាក់រអួល។សូមព្យាយាមម្ដងទៀតឬជ្រើសរើសវិធីទូទាត់ផ្សេងទៀតដែលមាន។",
                    payment_declined: "វិធីសាស្ត្របង់ប្រាក់របស់អ្នកត្រូវបានបដិសេធ",
                    card_declined: "កាតរបស់អ្នកត្រូវបានបដិសេធមិនអាចដំណើរការបានទេ",
                    promo_max_uses_exceeded: "លេខកូដប្រូម៉ូសិននេះបានដល់កម្រិតប្រើប្រាស់ហើយ ហើយមិនអាចប្រើបានទៀតទេ។",
                    store_closed: "ហាងបានបិទហើយក៏មិនទទួលការកំម្ម៉ងនាពេលនេះ",
                    accept_terms: "សូមមេត្តាពិនិត្យលក័្ខខណ្ឌផ្សេង",
                    required_payment: "សូមជ្រើសរើសយកវិធីបង់ប្រាក់",
                    required_phone: "សូមបំពេញលេខទូរស័ព្ទរបស់អ្នក",
                    required_email: "សូមបំពេញអ៊ីមែលរបស់អ្នក",
                    required_name: "សូមវាយបញ្ចូលឈ្មោះរបស់អ្នក",
                    invalid_email: "សូមវាយបញ្ចូល អ៊ីម៉ែលរបស់អ្នកអោយបានត្រឹមត្រូវ",
                    invalid_phone: "សូមវាយបញ្ចូលលេខទូរស័ព្ទរបស់អ្នកអោយបានត្រឹមត្រូវ",
                    invalid_cc_number: "លេខកាតឥណទានរបស់អ្នកមិនត្រឹមត្រូវទេ",
                    retry_cc_number: "លេខកាតឥណទានមិនត្រឹមត្រូវ សូមវាយបញ្ចូលលេខកាតឥណទានរបស់អ្នកម្តងទៀត",
                    closed: "ហាងបិទ/បិទ សុំមិនទទួលការបញ្ជាទិញ",
                    promo_login_required: "ត្រូវតែចូលនៅទីនេះដើម្បីប្រើប្រាប់ប្រូម៉ូសិន",
                    promo_used: "អ្នកបានប្រើប្រាប់ប្រូម៉ូសិននេះរួចរាល់ហើយ",
                },
                button: {
                    continue: "បន្តធ្វើការបង់ប្រាក់",
                    place_order: "ដាក់ការកំម្ម៉ង",
                },
            },
            customer: {
                age_v: {
                    title: "បញ្ជាក់អំពីអាយុ",
                    required_for_items: "តំរូវអោយកំម្ម៉ងទិញនូវចំនួនកំណត់ណាមួយ",
                    min_age: "អាយុតិចបំផុត/អាយុអប្បបរិមា {{age}} ឆ្នាំ",
                    est_time: "បញ្ជាក់អំពីពេលវេលាៈ {{time}} ម៉ោង",
                    upload_description: "បញ្ចូលអត្តសញ្ញាណប័ណ្ណរបស់អ្នកនៅខាងក្រោមដើម្បីផ្ទៀងផ្ទាត់។ អ្នកនឹងត្រូវបានជូនដំណឹងតាមរយៈអ៊ីម៉ែលនៅពេលដែលផ្ទៀងផ្ទាត់។ អាចបញ្ចូលផ្ទុករូបភាពរហូតដល់ទំហំអតិបរិមា ២ មេកាបៃនៃរូបនីមួយៗ",
                    pending_description_1: "សូមអរគុណចំពោះការដាក់ស្នើឯកសាររបស់អ្នក។ អ្នកនឹងត្រូវបានជូនដំណឹងតបវិញតាមរយៈអ៊ីម៉ែលនៅពេលដែលអ្នកត្រូវបានអនុម័ត",
                    pending_description_2: "ចុចគេហទំព័រឡើងវិញដើម្បីផ្ទៀងផ្ទាត់ធ្វើបច្ចុប្បន្នភាពគណនីរបស់អ្នក។ ប៉ាន់ស្មានពេលវេលាផ្ទៀងផ្ទាត់គឺ {{time}}ម៉ោង",
                    approved_description: "គណនីរបស់អ្នកត្រូវបានផ្ទៀងផ្ទាត់ហើយអ្នកអាចបញ្ជាទិញពីម៉ឺនុយដែលបានដាក់ជូន",
                    rejected_description: "អត្តសញ្ញាណប័ណ្ណរបស់អ្នកត្រូវបានបដិសេធ។ ប្រសិនបើអ្នកចង់ព្យាយាមម្តងទៀតសូមបញ្ចូលលេខសម្គាល់អត្តសញ្ញាណប័ណ្ណរបស់អ្នកឡើងវិញ",
                    upload: "បញ្ចូល",
                    reupload: "បញ្ចូលឯកសារម្តងទៀត",
                    go_back: "ត្រឡប់ក្រោយ",
                    view_document: "ត្រួតពិនិត្យមើលឯកសារ {{number}}",
                    status: {
                        unverified: "មិនទាន់បានបញ្ជាក់",
                        pending: "រង់ចាំការយល់ព្រម",
                        approved: "បានផ្ទៀងផ្ទាត់ដោយជោគជ័យ",
                        rejected: "បានបដិសេធ",
                    },
                },
                headings: {
                    sessions: "វគ្គ",
                    orders: "បញ្ជាទិញ",
                    spend: "ចំណាយ",
                    order_history: "ប្រវត្តិនៃការបញ្ជាទិញ",
                    loyalty_points: "ពិន្ទុភក្ដីភាព",
                },
            },
            custom_payment: {
                title: "{{name}} ទម្រង់ទូទាត់ប្រាក់",
                description: "អ្នកបានមកដល់ទម្រង់ទូទាត់តាមអ៊ីនធឺណិតរបស់យើងហើយ។ សូមបំពេញចន្លោះខាងក្រោមដើម្បីទូទាត់ប្រាក់។  ប្រសិនបើមិនបានវាយបញ្ចូលចំនួនទឹកប្រាក់ ព័ត៌មានលំអិតរបស់អ្នកនឹងត្រូវបានរក្សាទុក ប៉ុន្តែអ្នកនឹងមិនត្រូវបានគិតប្រាក់ឡើយ។",
                disabled: "ទំព័រនៃការទូទាត់តាមអ៊ីនធើណែតនេះមិនបានធានាត្រឹមត្រូវនៅឡើយទេ។  សូមទាក់ទងទៅម្ចាស់គេហទំព័រដើម្បីសាកសួរពត៍មានលំអិត",
                success: "ការទូទាត់របស់អ្នកត្រូវបានដំណើរការដោយជោគជ័យ ហើយព័ត៌មានលម្អិតរបស់អ្នកក៏ត្រូវបានរក្សាទុក។ សូមអរគុណ។",
                back: "ត្រឡប់ទៅទំព័រដើម",
                fields: {
                    name: "ឈ្មោះពេញ",
                    email: "អាស័យដ្ឋាន អ៊ីម៉ែល",
                    reference: "លេខសំគាល់នៃការបង់ប្រាក់",
                    amount: "ចំនួន ($)",
                    name_on_card: "ឈ្មោះនៅលើកាត",
                    submit: "ដាក់ការទូទាត់",
                },
                warning: {
                    currency: "ចំណាំៈ  ចំនួនទឹកប្រាក់ទូទាត់ {{actual}}, មិនមែន {{default}} ",
                },
                errors: {
                    generic: "មានភាពរអាក់រអួលសូមព្យាយាមម្តងទៀត ឫអាចទាក់ទងមកពួកយើង សំរាប់ពត៍មានបន្ថែម។",
                    stripe_generic: "ខុសកាតឥណទាន សូមចុចលើគេហទំព័រសាជាថ្មីម្តងទៀត",
                    payment_fail: "បរាជ័យក្នុងការទូទាត់ សូមមេត្តាព្យាយាមម្តងទៀត រឺជ្រើសរើសយកការទូទាត់តាមវិធីសាស្ត្រផ្សេងទៀតដែលមាន",
                    payment_cancelled: "ការទូទាត់ត្រូវបានលប់ចោល សូមមេត្តាព្យាយាមម្តងទៀត រឺជ្រើសរើសយកការទូទាត់តាមវិធីសាស្ត្រផ្សេង",
                    payment_error: "មានការរអាក់រអួលក្នុងពេលដំណើរការនៃការទូទាត់ សូមមេត្តាព្យាយាមម្តងទៀត ឫជ្រើរើសយកការទូទាត់តាមវិធីសាស្រ្តផ្សេងដែលមាន",
                    payment_declined: "វិធីសាស្ត្រនៃការទូទាត់របស់អ្នកត្រូវបានបដិសេធ។",
                    card_declined: "កាតរបស់អ្នកត្រូវបានបដិសេធ ហើយការទូទាត់មិនអាចដំណើរការបន្តទៀតបានទេ។",
                    promo_max_uses_exceeded: "លេខកូដប្រូម៉ូសិននេះបានដល់កម្រិតប្រើប្រាស់ហើយ ហើយមិនអាចប្រើបានទៀតទេ។",
                },
            },
            dish: {
                add: "បន្ថែមចូលកន្ត្រក",
                edit: "ផលិតផលបន្ថែមថ្មី",
                notes: "សេចក្តីណែនាំពិសេស",
                ingredients: {
                    title: "គ្រឿងផ្សំ",
                    uncheck_remove: "ដក សញ្ញា (ធីក) ដើម្បើយកចេញ",
                },
                ingredients_title: "គ្រឿងផ្សំ",
                combo: {
                    choose_dish: "ជ្រើសរើសម្ហូប",
                },
                option_sets: {
                    conditions: {
                        select_one: "ជ្រើសរើសមួយ (ចាំបាច់)",
                        select_one_optional: "ជ្រើសរើសមួយ (អាចរើសបាន)",
                        select_between: "ជ្រើរើសចន្លោះពី {{min}} - {{max}} (ចាំបាច់)",
                        select_at_least: "ជ្រើសរើសយ៉ាងហោចណាស់ {{qty}} (ចាំបាច់)",
                        select_up_to: "ជ្រើសរើសរហូតដល់ {{qty}} (អាចរើសបាន)",
                        select_multiple: "ជ្រើសរើសច្រើនមុខ (អាចរើសបាន)",
                        free_amount: "ជំរើសទី១ {{qty}} ឥតគិតថ្លៃ / {{selected}} បានជ្រើសរើស",
                    },
                },
                error: "ជ្រើសរើសជម្រើសណាមួយដែលមានពណ៌ក្រហម",
                added_to_cart: "ការកំម្ម៉ងបញ្ចូលទៅក្នុងកន្រ្តក",
            },
            map: {
                zone_fee: "ថ្លៃដឹកជញ្ជូន",
                view_in_google: "មើលនៅក្នុងផែនទី ហ្គូហ្គល",
            },
            portal_go_back: {
                title: "ចង់ត្រឡប់ទៅស្វែងរកនៅក្នុងភោជនីយដ្ឋានវិញ?",
                description: "ការកំម្ម៉ងដែលនៅក្នុងកន្ត្រកទំនិញរបស់អ្នកនឹងត្រូវបាត់បង់។",
                cancel: "លប់ចោល",
                proceed: "ត្រឡប់ទៅទំព័រដើម",
            },
            order: {
                config: {
                    services: {
                        title: "ជ្រើសរើសសេវាកម្ម",
                        table_booking: "កក់តុ",
                    },
                    address_custom: {
                        input_placeholder: "វាយបញ្ចូលអាស័យដា្ឋនរបស់អ្នក",
                    },
                    address: {
                        input_placeholder: "រកអាស័យដ្ឋានសំរាប់ដឹកជញ្ជូនរបស់អ្នក",
                        extras_placeholder: "អាចជ្រើសរើសបានៈ លេខឯកតា, ឈ្មោះអគារ ។ល។",
                        search_placeholder: "ស្វែងរកអាស័យដ្ឋានរបស់អ្នក",
                        not_found: "អាស័យដ្ឋានដឹកជញ្ជូនមិនត្រឹមត្រូវ រកមិនឃើញ សូមព្យាយាមម្តងទៀត",
                        not_delivering: "ឥឡូវយើងមិនបានបញ្ជូនទៅតាមអាស័យដ្ឋាននេះទេ",
                        not_in_range: "អាស័យដ្ឋានរបស់អ្នកមិនស្ថិតនៅក្នុងទីតាំងហាងរបស់យើងទេ",
                        not_in_zone: "អាស័យដ្ឋានរបស់អ្នកមិនស្ថិតនៅក្នុងតំបន់ចែកចាយសកម្មយើងទេ",
                        location_permission: "អនុញ្ញាតឱ្យគេហទំព័រនេះចូលប្រើទីតាំងបច្ចុប្បន្នរបស់អ្នក?",
                        location_permission_warning: "មិនអាចចូលប្រើទីតាំងបច្ចុប្បន្នរបស់អ្នកបានទេ។ សូមបើកសេវាកម្មទីតាំងនៅលើឧបករណ៍ និងកម្មវិធីរុករកតាមអ៊ីនធឺណិតរបស់អ្នក។ នេះជាឯកសារយោងមួយចំនួន៖",
                        pick_location: "ជ្រើសរើសទីតាំងរបស់អ្នក។",
                        pick_location_help_text: "អូសសញ្ញាសម្គាល់ដើម្បីជ្រើសរើសទីតាំងនៅលើផែនទី។",
                        use_current_location: "ប្រើទីតាំងបច្ចុប្បន្ន",
                        locate_on_map: "កំណត់ទីតាំងនៅលើផែនទី",
                    },
                    datetime: {
                        title: "តើអ្នកចង់បានការបញ្ជាទិញរបស់អ្នកនៅពេលណា?",
                        due_now: "ឥឡូវនេះ",
                        due_later: "បន្តិចទៀត",
                        service_not_available: "សូមអភ័យទោស ពួកយើងមិនទទួលការបញ្ជាទិញទេ {{service}}",
                        currently_closed: "{{service}} ឥឡូវបិទ ប៉ុន្តែអ្នកអាចធ្វើការបញ្ជាទិញម្តងទៀតនៅពេលក្រោយ",
                        due_unavailable: "មិនអាចប្រើបាន",
                        due_closed: "បិទ",
                        select_date: "ជ្រើសរើសកាលបរិចេ្ឆទ",
                        select_time: "ជ្រើសរើសពេលវេលា",
                        select_order_date: "ជ្រើសរើសកាលបរិចេ្ឆទបញ្ជាទិញរបស់អ្នក",
                        select_order_time: "ជ្រើសរើសពេលវេលា",
                        select_booking_date: "ជ្រើសរើសកាលបរិចេ្ឆទកក់ទុកមុនរបស់អ្នក",
                        select_booking_time: "ជ្រើសរើសពេលវេលានៃការកក់មុនរបស់អ្នក",
                        no_times_available: "មិនមានពេលវេលាដែលអាចជ្រើសរើសបាន",
                        date_today: "(ថ្ងៃនេះ)",
                        date_closed: "(បិទ)",
                        date_bookings_paused: "(ការកក់ត្រូវបានផ្អាក)",
                        time_slot_closed: "បិទ",
                    },
                    number_of_people: {
                        placeholder: "ចំនួនមនុស្ស",
                    },
                    table: {
                        select: "ជ្រើសរើសតុ",
                        select_popup_title: "ជ្រើសរើសតុរបស់អ្នក",
                        password: "លេខសម្ងាត់តុ",
                        password_warning: "វាយបញ្ចូលលេខតុសម្ងាត់ដើម្បីដំណើរការ",
                    },
                    warning: {
                        closed: "សូមអភ័យទោស ឥឡូវត្រូវបានបិទ/ ពួកយើងមិនទទួលការបញ្ជាទិញទេ",
                        not_available: "សូមអភ័យទោស ពួកយើងមិនទទួលការបញ្ជាទិញទេ",
                    },
                    start_button: "ចាប់ផ្តើមការបញ្ជាទិញ",
                },
                history: {
                    invalid: "មិនទទួលការបញ្ជាទិញឡើងវិញទេព្រោះរបស់របរខ្លះមួយចំនួនដែលបានបញ្ជាទិញត្រូវបានកែប្រែឫ មិនមានទៀតទេ",
                },
                reorder: {
                    title: "បញ្ជាទិញជាថ្មីឆាប់រហ័ស",
                    description: "មានភាពងាយស្រួលក្នុងការបញ្ជាទិញទំនិញ ពីការបញ្ជាទិញពីមុន",
                },
            },
            receipt: {
                errors: {
                    not_found: "រកមិនឃើញនៃការបញ្ជាទិញ សូមចុចឡើងវិញនៅក្នុងគេហទំព័រ ហើយព្យាយាមម្តងទៀត",
                    booking_not_found: "ការកក់មិនមានទេ។ វាអាចត្រូវបានលុប",
                    generic: "មានភាពរអាក់រអួលព្យាយាមម្តងទៀត ឫអាចទាក់ទងមកពួកយើង",
                },
                connection: {
                    connected: "ធ្វើបច្ចុប្បន្នភាពពេលវេលាពិត",
                    connecting: "កំពុងតភ្ជាប់ការធ្វើបច្ចុប្បន្នភាពពេលវេលាពិត",
                    disconnected: "មិនបានភ្ជាប់ការធ្វើបច្ចុប្បន្នភាពពេលវេលាពិត",
                },
            },
            warnings: {
                logout: {
                    pretitle: "ការព្រមាន",
                    title: "ចាកចេញ",
                    body: "ចាកចេញហើយការកំម្ន៉ងរបស់អ្នកដែលមានក្នុងកន្ត្រកនឹងត្រូវលប់ចោល",
                    cancel: "លប់ចោល",
                    proceed: "ដំណើរការ",
                },
                order_restart: {
                    warning: "ការព្រមាន",
                    title: "ផ្លាស់ប្តូរព័ត៌មានលំអិតនៃការបញ្ជាទិញ",
                    body: "ផ្លាស់ប្តូរព័ត៌មានលំអិតនៃការបញ្ជាទិញរបស់អ្នកដោយកន្រ្តកទំនិញអ្នកនឹងដករបស់របរខ្លះចេញ ដោយសាប្រហែលរបស់របរខ្លះមិនមាន",
                    cancel: "លប់ចោល",
                    proceed: "ដំណើរការ",
                },
                order_expired: {
                    subtitle: "សំខាន់",
                    title: "ការបញ្ជាទិញត្រូវបានប្តូរ",
                    description: "ពេលវេលាដែលបានជ្រើសរើសសម្រាប់ការបញ្ជាទិញរបស់អ្នកឥឡូវនេះនៅជិតបង្កើយ។ ការបញ្ជាទិញរបស់អ្នកត្រូវបានកែប្រែជូនអ្នករួចរាល់ហើយ",
                    button: "យល់ព្រម",
                },
                order_expiring: {
                    subtitle: "សំខាន់",
                    title: "ការបញ្ជាទិញនឹងផុតកំណត់នៅក្នុងពេលដ៏ខ្លីខាងមុខនេះ",
                    description: "សូមដាក់ការបញ្ជាទិញរបស់អ្នកមុន {{time, timeFromTimestamp}} បើមិនដូច្នេះទេ វានឹងលែងមានសុពលភាពហើយ",
                    button: "យល់ព្រម",
                },
                location_permission: {
                    cancel: "លប់ចោល",
                    proceed: "ដំណើរការ",
                },
            },
            maps: {
                cancel: "លប់ចោល",
                use_location: "ប្រើទីតាំង",
            },
        },
        sections: {
            nav_top: {
                guest: "ភ្ញៀវ",
                login: "ចូល",
                login_signup: "ចូល / ចុះឈ្មោះ",
                logout: "ចាកចេញ",
            },
            menus: {
                info: {
                    no_menus: "មិនមានម៉ីនុយទេ",
                    restrictions: "ម៉ីនុយដាក់មានកម្រិត",
                    not_available: "ពេលនេះម៉ីនុយមិនមានទេ",
                    unavailable: {
                        times: "ម៉ីនុយមិនអាចប្រើបានការបញ្ជាទិញដែលអ្នកចង់បាន មិនមានទេ",
                        services: "ម៉ីនុយមិនអាចប្រើបានការបញ្ជាទិញដែលអ្នកចង់បាន មិនមានទេ",
                        hours: "ម៉ីនុយមិនអាចប្រើបាន ម៉ោងពេលនៃការបញ្ជាទិញរបស់អ្នក មិនស្ថិតក្នុងម៉ោងពេលនៅក្នុងម៉ីនុយមានទេ",
                        pre_order: "ម៉ិនុយមិនអាចប្រើបាន ការបញ្ជាទិញរបស់អ្នក មិនត្រូវនឹងតម្រូវការបញ្ជាទិញជាមុនទេ",
                        age: "ម៉ីនុយមិនអាចប្រើបាន អ្នកត្រូវចុះឈ្មោះ ជាមួយនឹងអាយុរបស់អ្នក ដើម្បីអាចបញ្ជាទិញក្នុងម៉ីនុយនេះបាន",
                    },
                    services: {
                        title: "តម្រូវការនៃការបញ្ជាទិញ",
                        pickup: "ជ្រើសរើសយក",
                        delivery: "ការចែកចាយ",
                        dine_in: "ទទួលទានអាហារពេលល្ងាចក្នុងហាង",
                    },
                    times: {
                        now: "គ្មានការបញ្ជាទិញជាមុន",
                        later: "សម្រាប់តែការបញ្ជាទិញជាមុនតែប៉ុណ្ណោះ",
                    },
                    hours: {
                        title: "ម៉ោងដែលអាចបញ្ជាទិញបាន",
                    },
                    preorder: {
                        title: "តម្រូវការនៃការបញ្ជាទិញជាមុន",
                        days_in_advance: "ត្រូវបញ្ជាទិញប៉ុន្មាន {{days}} ថ្ងៃមុន",
                        cutoff_time: "ថ្ងៃចុងក្រោយកាត់បន្ថយពេលវេលានៅ {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "កំហិតអាយុ",
                        approved: "គណនីរបស់អ្នកត្រូវបានផ្ទៀងផ្ទាត់ហើយអ្នកអាចបញ្ជាទិញពីម៉ឺនុយដែលបានដាក់ជូន",
                        rejected: "ស្នើសុំបញ្ជាក់អំពីអាយុដើម្បី បញ្ជាទិញ ។ បង្កើតគណនី និងបញ្ចូលអត្ថសញ្ណាណប័ណ",
                    },
                },
            },
            info: {
                location: {
                    title: "ទីតាំង",
                    view_map: "មើលផែនទី",
                    phone: "ទូរស័ព្ទ",
                },
                hours: {
                    title: "ម៉ោងបើក",
                    title_special: "ម៉ោងបើកសំខាន់",
                },
                services: {
                    title: "សេវាកម្ម",
                    notes: "ចំណាំ",
                    delivery: {
                        ranges: "តំបន់ចែកចាយ",
                        zones: "ទីតាំងចែកចាយ",
                        view_zones: "មើលតំបន់នៅលើផែនទី",
                        fee: "ថ្ងៃដឹកជញ្ជូន",
                        fee_short: 'ថ្លៃ',
                        fee_varies: "ប្រែប្រួល  ត្រូវបានបង្ហាញក្នុងកន្ត្រក",
                        min_order: "ការបញ្ជាទិញជាអប្បបរមា",
                        min_order_short: 'កម. អប.',
                        no_min_order: "គ្មានការបញ្ជាទិញជាអប្បបរមា",
                        free_amount: "ចំនួននៃការដឹកជញ្ជូនឥតគិតថ្លៃ",
                    },
                },
            },
            contact: {
                title: "ទាក់ទងមកយើង",
                name: "ឈ្មោះ",
                email: "អ៊ីមែល",
                phone: "លេខទូរស័ព្ទ",
                message: "បញ្ចូលសាររបស់អ្នក",
                send: "ផ្ញើរសារ",
                success: "សាររបស់អ្នកត្រូវបានបញ្ជូនទៅដោយជោគជ័យ",
                error: "មានភាពរអាក់រអួល ព្យាយាមម្តងទៀតនៅពេលក្រោយ",
            },
            footer: {
                powered_by: "ដំណើរការដោយ",
                terms_and_conditions: "លក្ខខណ្ឌ",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'បង្កាន់ដៃកក់លុយ',
            details: {
                datetime: 'កក់សម្រាប់',
                number_of_people: 'ចំនួនមនុស្ស',
                placed: 'ទីកន្លែង',
                updated: 'ឆែកជាលើកចុងក្រោយ',
                notes: 'ចំណាំ',
                name: 'ឈ្មោះ',
                email: 'អ៊ីមែល',
                phone: 'ទូរស័ព្ទ',
                store_address: 'អាស័យដ្ឋានហាង',
            },
            status_update: {
                title: 'កក់ទុក {{number}} ចុងក្រោយ',
                body: 'ការកក់របស់អ្នកត្រូវបានឆែកជាលើកចុងក្រោយ {{status}}',
            },
            email_status_update_customer: {
                subject: 'ការកក់ #{{number}} – {{subjectLabel}}',
                body: 'ការកក់ #{{number}} របស់អ្នកនៅ {{store}} ឥឡូវនេះគឺ {{status}}។',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'ការបញ្ជាទិញ #{{number}} – {{subjectLabel}}',
        header: 'ម៉ោងរួចរាល់ដែលបានធ្វើបច្ចុប្បន្នភាព',
        title: 'ម៉ោងរួចរាល់ដែលបានធ្វើបច្ចុប្បន្នភាព',
        order_number: 'លំដាប់: {{number}}',
        description: 'ការបញ្ជាទិញរបស់អ្នកនឹងរួចរាល់នៅម៉ោង {{time}}។',
        order_time_updated_to: 'ម៉ោងការបញ្ជាទិញរបស់អ្នកត្រូវបានធ្វើបច្ចុប្បន្នភាព។',
        powered_by: 'ឧបត្ថម្ភដោយ {{name}}',
        button_text: 'តាមដានការបញ្ជាទិញ',
        subject_label: 'ម៉ោងរួចរាល់ដែលបានធ្វើបច្ចុប្បន្នភាព',
        subject_label_delivery: 'ម៉ោងដឹកជញ្ជូនដែលបានធ្វើបច្ចុប្បន្នភាព',
        body_ready: 'ការបញ្ជាទិញរបស់អ្នកនឹងរួចរាល់នៅម៉ោង {{time}}។',
        body_delivery: 'ការបញ្ជាទិញរបស់អ្នកនឹងត្រូវដឹកជញ្ជូននៅម៉ោង {{time}}។',
    },
    order: {
        receipt: {
            est_ready_time: 'ការប៉ាន់ស្មានពេលវេលាដែលការកំម្មង់ត្រូវរួចរាល់',
            est_driver_pickup_time: 'ការប៉ាន់ស្មានពីពេលវេលាអ្នកដែលអាចមកទទួលយក',
            est_delivery_time: 'ការប៉ាន់ស្មានមើលពីពេលវេលាចែកចាយ',
            tab_details: 'លំអិត',
            tab_dishes: 'មុខម្ហូប',
            details: {
                status: 'ស្ថានភាព',
                placed: 'ទីកន្លែង',
                due: 'ដល់កំណត់',
                due_asap: 'ឥឡូវ / កាន់តែឆាប់កាន់តែល្អ',
                last_updated: 'ឆែកជាលើកចុងក្រោយ',
                total: 'សរុប',
                type: 'ប្រភេទ',
                table: 'តុ',
                number_of_people: 'ចំនួនមនុស្ស',
                payment_method: 'វិធីសាស្ត្រនៃការទូទាត់',
                payment_status: 'ស្ថានភាពនៃការទូទាត់',
                payment_currency: 'ទូទាត់ជារូបិយប័ណ្ណ',
                notes: 'ចំណាំ',
                name: 'ឈ្មោះ',
                email: 'អ៊ីមែល',
                phone: 'ទូរស័ព្ទ',
                distance: 'ចំងាយ',
                driving_time: 'រយះពេលបើកបរ',
                delivery_zone: 'តំបន់',
                delivery_address: 'អាស័យដ្ឋានសម្រាប់ការចែកចាយ',
                delivery_tracking: 'តាមដានការចែកចាយ',
                delivery_tracking_link: 'តាមដានពេលវេលាពិតតាមលីង',
                tookan_status: ' ស្ថានភាពTookan ',
                tookan_status_failed_book: 'សំណើរសុំដឹកជញ្ជូនមិនជោគជ័យទេ',
                tookan_status_failed_update: 'បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពកក់ទុក',
                tookan_status_success: 'កក់ទុកសម្រាប់ការដឹកជញ្ជូន',
                store_address: 'រក្សាទុកអាស័យដ្ឋាន',
            },
            dishes: {
                headings: {
                    quantity: 'បរិមាណ',
                    item: 'មុខម្ហូប/ផលិតផល',
                    price: 'តម្លៃ',
                },
                notes: 'ចំណាំ',
                remove_ingredients: 'ដកគ្រឿងផ្សំចេញ',
            },
            status_update: {
                title: 'បញ្ជាទិញ  {{number}}  ចុងក្រោយ',
                body: 'ស្ថានភាពនៃការបញ្ជាទិញរបស់អ្នកត្រូវបានធ្វើបច្ចុប្បន្នភាពទៅ {{status}}',
            },
            wait_time_update: {
                title: 'Order {{number}} Updated',
                body: 'ពេលវេលានៃការបញ្ជាទិញរបស់អ្នកត្រូវបានធ្វើបច្ចុប្បន្នភាព',
            },
            delivery_update: {
                title: 'បញ្ជាទិញ {{number}} ចុងក្រោយ',
                body: 'ការបញ្ជាទិញរបស់អ្នកត្រូវបានកក់សម្រាប់ការដឹកជញ្ជូន សូមតាមដានពេលវេលាពិតប្រាកដតាមលីង',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "តាមដានលំដាប់",
                track_delivery_button_text: "តាមដានការដឹកជញ្ជូន",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "តាមដានលំដាប់",
                track_delivery_button_text: "តាមដានការដឹកជញ្ជូន",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) inc. in price",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "ថ្លៃដឹកជញ្ជូន",
            promo: "បញ្ចុះតម្លៃ : {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "បញ្ចុះតម្លៃ :  {{name}} ({{percent}}%)",
            promo_fixed: "បញ្ចុះតម្លៃ :  {{name}}",
            promo_none: "បញ្ចុះតម្លៃ :  {{name}}",
            cart: "កន្រ្តក",
            tip: "លុយធីប",
            total: "សរុប",
        },
        status: {
            unconfirmed: "អត់បញ្ជាក់",
            awaiting_payment: "រង់ចាំការទូទាត់",
            confirmed: "បញ្ជាក់",
            ready: "ត្រៀមខ្លួនរួចជាស្រេច",
            on_route: "កំពុងនៅតាមផ្លូវ",
            complete: "រួចរាល់",
            cancelled: "លប់ចោល",
            seated: "បានអង្គុយ",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "មិនមាន",
                },
            },
            dish: {
                no_stock: "អស់ពីស្តុក",
                not_available: "មិនមាន",
            },
        },
    },
};
//# sourceMappingURL=km.js.map